import { useCallback, useEffect, useRef } from 'react'
import ringtone from 'assets/sounds/ringtone-043.mp3'

export const useRingtone = (timeoutMs: any = 60000) => {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  if (!audioRef.current) {
    audioRef.current = new Audio(ringtone)
    audioRef.current.loop = true
  }

  const clearRingTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const stop = useCallback(() => {
    clearRingTimeout()

    const audio = audioRef.current
    if (!audio) return

    audio.pause()
    audio.currentTime = 0
  }, [clearRingTimeout])

  const play = useCallback(
    (onTimeout?: () => void) => {
      const audio = audioRef.current
      if (!audio) return

      clearRingTimeout()

      audio.currentTime = 0
      audio.play().catch((error) => {
        console.error('Error playing ringtone:', error)
      })

      timeoutRef.current = setTimeout(() => {
        stop()
        onTimeout?.()
      }, timeoutMs)
    },
    [clearRingTimeout, stop, timeoutMs],
  )

  useEffect(() => {
    return () => {
      stop()
    }
  }, [stop])

  return { play, stop }
}